import React from 'react';
import { ColumnDefinition, RowDefinition, Table, useTableState } from '@indigo-ag/component-module';
import i18next from 'i18next';

import { createStylesHook } from 'shared';
import { Detail } from '@indigo-ag/schema';
import { SerasaOccurrenceDetailsTable } from '../components/BackgroundCheck/SerasaBacen/Serasa/SerasaOccurrenceDetailsTable';

const useStyles = createStylesHook({
  tableWrapper: {
    margin: '10px 0px 40px 0px'
  }
});

export interface PropsTableTab {
  rows: TableRowsTab[];
  total: string;
}

export interface TableRowsTab {
  amount: string;
  name: string;
  type: string;
  contact?: string;
  count?: number;
  details?: Detail[];
}

interface TotalColumn {
  total: string;
}

type ColumnId = 'amount' | 'name' | 'type' | 'contact' | 'count';
type TotalColumnId = 'total';

const columndDefinition: ColumnDefinition<TableRowsTab, ColumnId>[] = [
  {
    id: 'type',
    header: i18next.t('type'),
    cell: ({ row, SimpleCell }) => <SimpleCell label={row.type} />
  },
  {
    id: 'contact',
    header: i18next.t('contact'),
    cell: ({ row, SimpleCell }) => <SimpleCell label={row.contact ?? ''} />
  },
  {
    id: 'name',
    header: i18next.t('name'),
    cell: ({ row, SimpleCell }) => <SimpleCell label={row.name} />
  },
  {
    id: 'count',
    header: i18next.t('serasaRestrictionsDetailTable_amount'),
    cell: ({ row, SimpleCell }) => <SimpleCell label={row.count?.toString() ?? ''} />
  },
  {
    id: 'amount',
    header: i18next.t('serasaRestrictionsDetailTable_value'),
    cell: ({ row, SimpleCell }) => <SimpleCell label={row.amount} />
  }
];

const totalColumnDefinition: ColumnDefinition<TotalColumn, TotalColumnId>[] = [
  {
    id: 'total',
    header: 'Total',
    cell: ({ row, SimpleCell }) => <SimpleCell label={row.total} />
  }
];

const rowDefinition: RowDefinition<TableRowsTab, ColumnId> = {
  rowId: ({ row }) => row.name,
  expandable: ({ row, ColumnSpan }) => (
    <ColumnSpan>
      <SerasaOccurrenceDetailsTable details={row.details ?? []} />
    </ColumnSpan>
  )
};

const totalRowDefinition: RowDefinition<TotalColumn, TotalColumnId> = {
  rowId: ({ row }) => `${row.total}`
};

export const TableTab: React.FunctionComponent<PropsTableTab> = ({ rows, total }) => {
  /**
   * Styles
   */
  const classes = useStyles();

  const dataRows: TableRowsTab[] = rows.map(row => {
    return {
      type: row.type,
      name: row.name,
      amount: row.amount,
      contact: row.contact,
      count: row.count,
      details: row.details
    };
  });

  const tableState = useTableState(dataRows);

  const totalRow: TotalColumn[] = [
    {
      total
    }
  ];

  return (
    <>
      <Table label="Table Tab" columnDefinition={columndDefinition} rowDefinition={rowDefinition} {...tableState} />
      <div className={classes.tableWrapper}>
        <Table
          label="Total"
          columnDefinition={totalColumnDefinition}
          rowDefinition={totalRowDefinition}
          data={totalRow}
        />
      </div>
    </>
  );
};
